import { Box, Stack, Typography, alpha, styled } from '@mui/material';

export const CardRow = styled(Stack)(({ theme }) => ({
  flexDirection: 'row',
  alignItems: 'center',
  gap: '12px',
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: '16px',
  padding: '13px 15px',
  backgroundColor: alpha(theme.palette.text.secondary, 0.04),
}));

// Gold chip, matching the order panel below it. The dialog was navy on navy;
// gold is what the store uses to mark value, so the two accents now alternate
// down the sheet instead of stacking.
export const IconChip = styled(Box)(({ theme }) => ({
  width: 38,
  height: 38,
  borderRadius: '11px',
  flexShrink: 0,
  display: 'grid',
  placeItems: 'center',
  color: theme.palette.brand.onGold,
  background: `linear-gradient(145deg, ${theme.palette.guidedCourse.gold}, ${theme.palette.guidedCourse.goldDeep})`,
  boxShadow: `0 3px 0 ${theme.palette.guidedCourse.goldDeep}`,
}));

export const CopyStack = styled(Stack)({
  flex: 1,
  gap: '2px',
  minWidth: 0,
});

export const Label = styled(Typography)(({ theme }) => ({
  fontSize: '10.5px',
  fontWeight: 700,
  letterSpacing: 0.6,
  textTransform: 'uppercase',
  color: theme.palette.text.secondary,
}));

export const AddressLine = styled(Typography)(({ theme }) => ({
  fontSize: '14px',
  fontWeight: 700,
  color: theme.palette.text.primary,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
}));
